export default {
  核心技术: 'Core technology',
  云端建筑企业: 'Establish A Virtual Company',
  szls提示1: 'Establish a company online to connect the digital to the physical world',
  开启您的数字世界: 'Start Your Digital Trade',
  实景克隆工具: 'Built A Virtual Showroom',
  szls提示2: 'Built all-round showrooms of enterprises and digital factories by 3D visualization tools',
  数字贸易升级: 'Upgrade the Digital Trade',
  szls提示3:
    'Facilitate the digital transformation and upgrading of enterprises, and achieve the efficiency and cost reduction management',
  立即构建您的云展厅: 'Build your digital-twin enterprise',
  空间重建: 'Scene Reconstruction',
  空间互动: 'Digital Interaction',
  空间展示: 'Virtual Showcase',
  szls提示4: 'Digital twin, Virtual Factory Tour',
  szls提示5: '720° Product Photos help you acquire more enterprise information',
  构建您的数字孪生场景: 'Build your digital-twin enterprise',
  展实力3D展厅: '3D exhibition helps to show',
  巡产线3D工厂: '3D factory helps to display',
  看产品3D产品: '3D products helps to see',
  案例分享: 'Cases',
  了解更多: 'Learn More',
  szls提示6: 'Visiting 24-hour virtual exhibition',
  打破时空限制: 'No time and space restriction',
  szls提示7: '365 days non-stop display',
  实现24小时云上贸易: '24-hour online trade',
  szls提示8: '720° Product Photos help you acquire more enterprise information',
  szls提示9: 'know more about enterprises’ strength',
  szls提示10: 'Build customers’ trust and boost sales',
  szls提示11: 'Build all-round digital exhibitions for enterprises',
  szls提示12: 'Assist in automated marketing',
  szls提示13: 'Reduce cost and grasp clients effectively',
  打破二维格局: 'Break 2D limitation',
  营销自动化: 'Marketing Automation',
}
